import { map } from 'lodash';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FormikSelect } from 'components';
import { PAYOUT_DISPUTE_SELECT_DETAILS } from 'constants/order.constants';
import { TranslationNamespace } from 'i18n';
import { orderUtils } from 'utils';

type Props = {
  name?: string;
};

export const DisputeSelect: React.FC<Props> = ({ name = 'statusDetails' }) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.orders',
  });
  const options = useMemo(
    () =>
      map(PAYOUT_DISPUTE_SELECT_DETAILS, (value) => ({
        value,
        label: orderUtils.getPayoutStatusDetailsLabel(value),
      })),
    [],
  );

  return (
    <FormikSelect
      label={t('resolve.reason')}
      name={name}
      noneOption={false}
      options={options}
      fullWidth
      size="small"
    />
  );
};
